var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-user',{attrs:{"role":_vm.role,"sysName":_vm.$config.sysName+'-后台管理',"isAdminLogin":true,"bgUrl":_vm.bgUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }